<template>
  <div class="talk-memo-msg-container">
    <div class="flex-align" style="gap:8px;margin-bottom:8px">
      <div class="body5-medium primary">내부 메모</div>
      <button class="button btn-edit" v-if="item.info && !editable" @click="clickEdit">수정</button>
    </div>
    <div v-if="item.info">
      <table class="msg-table">
        <tr>
          <th>채널</th>
          <td>
            <div v-if="editable" class="radio-group">
              <div class="radio-item" v-for="(channel, idx) in option.channel" :key="`opt-ch-${idx}`">
                <input type="radio" :id="`channel-${idx}`" :value="channel" v-model="value.info.channel">
                <label :for="`channel-${idx}`">{{ channel }}</label>
              </div>
            </div>
            <template v-else>{{ item.info.channel }}</template>
          </td>
        </tr>
        <tr>
          <th>고객서비스 담당자</th>
          <td>
            <input v-if="editable"
                   type="text" class="manager input-border"
                   v-model="value.info.manager" placeholder="고객서비스 담당자">
            <template v-else>{{ item.info.manager }}</template>
          </td>
        </tr>
        <tr>
          <th>세부내용</th>
          <td>
            <textarea v-if="editable" class="input-border"
                      v-model="value.message"
                      @keyup="e => value.message = e.target.value" rows="3"></textarea>
            <template v-else>{{ item.message }}</template>
          </td>
        </tr>
        <tr><th>첨부파일</th>
          <td>
            <template v-if="editable">
              <input type="file" id="memo-file-uploader"
                     @change="onFileChange"
                     accept="image/gif, image/jpeg, image/png, .docx, .pptx, .xlsx, .hwp, .pdf, .zip">
              <label for="memo-file-uploader">
                <div class="button is-gray" style="width: 100%">파일첨부</div>
              </label>
              <div v-if="value.file">{{ value.file.name ? value.file.name : decodeURI(item.file.split('/').slice(-1)[0]) }}</div>
            </template>
            <a v-else-if="item.file"
               :href="item.file"
               target="_blank">{{ decodeURI(item.file.split('/').slice(-1)[0]) }}</a>
          </td>
        </tr>
        <tr>
          <th>참고링크</th>
          <td>
            <input v-if="editable"
                   type="text" class="grid-item input-border" v-model="value.info.link" placeholder="참고 링크 주소">
            <a v-else-if="item.info.link && item.info.link !== ''"
               :href="item.info.link"
               target="_blank">{{ item.info.link }}</a>
          </td>
        </tr>
        <tr>
          <th>구분</th>
          <td>
            <select v-if="editable"
                    class="input-border" v-model="value.info.cat1" @change="onChange">
              <option :value="0">구분</option>
              <option v-for="(cat, idx) in option.cats1" :key="`opt-cat1-${idx}`"
                      :value="cat.id">{{ cat.name }}</option>
            </select>
            <template v-else>{{ item.info.cat1 === 0 ? '-' : item.info.cat1 }}</template>
          </td>
        </tr>
        <tr>
          <th>구분2</th>
          <td>
            <select v-if="editable"
              class="input-border" v-model="value.info.cat2">
              <option :value="0" disabled>구분2</option>
              <option v-for="(cat, idx) in option.cats2" :key="`opt-cat2-${idx}`"
                      :value="cat.id">{{ cat.name }}</option>
            </select>
            <template v-else>{{ item.info.cat2 === 0 ? '-' : item.info.cat2 }}</template>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>{{ item.message }}</div>
    <div class="button-group" v-if="editable">
      <button class="button is-light" @click="clickCancel">취소</button>
      <button class="button is-primary" @click="clickAccept">저장</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TalkMemoMsg',
    props: {
      talkId: {
        type: Number
      },
      item: {
        type: Object
      }
    },
    data() {
      return {
        editable: false,
        value: {
          info: {
            cat1: 0,
            cat2: 0,
            manager: '',
            channel: '메모',
            link: ''
          },
          file: undefined,
          message: ''
        },
        option: {
          cats1: [],
          cats2: [],
          channel: ['메모', '전화', '이메일', '홈페이지', '오프라인 미팅', '이메일&전화', '시트', '카카오톡']
        },
      }
    },
    methods: {
      async clickEdit() {
        this.editable = true;
        await this.init();
        let value = this.cloneItem(this.item);
        if(value.info.cat1 !== '구분' && value.info.cat1 !== 0) {
          let cat1 = this.option.cats1.filter(i=> i.name === value.info.cat1)[0];
          value.info.cat1 = cat1.id;
          this.option.cats2 = cat1.child;
          value.info.cat2 = cat1.child.filter(i=> i.name === value.info.cat2)[0].id;
        }
        this.value = value;

      },
      async init() {
        if(this.option.cats1.length === 0) {
          let res = await this.$axios.get(this.getUrl('memo_category'));
          this.option.cats1 = res.data;
        }
      },
      onFileChange(e) {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onload = f => {
          let ext = '';
          if(file.name.indexOf('.')>-1) {
            ext = file.name.split('.').slice(-1)[0];
          }
          this.value.file = {
            name: file.name,
            file: f.target.result,
            size: file.size,
            extension: ext
          }
        }
        reader.readAsDataURL(file);
      },
      onChange() {
        let cats = this.option.cats1.filter(i=>i.id === this.value.info.cat1);
        if(cats.length>0) {
          this.option.cats2 = cats[0].child;
          this.value.info.cat2 = this.option.cats2[0].id;
        } else {
          this.option.cats2 = [];
          this.value.info.cat2 = 0;
        }
      },
      getValue() {
        let value = this.cloneItem(this.value.info);
        let cat1 = this.option.cats1.filter(i=>i.id === value.cat1);
        if(cat1.length>0) {
          cat1 = cat1[0];
          value.cat1 = cat1.name;
          value.cat1_id = cat1.id;
          value.cat2 = cat1.child.filter(i=>i.id === value.cat2)[0].name;
        }
        return value;
      },
      clickCancel() {
        this.editable = false;
      },
      clickAccept() {
        let params = this.cloneItem(this.value);
        params.info = this.getValue();
        if(params.info.cat1_id) {
          params.cat1_id = params.info.cat1_id;
        }
        this.$axios.patch(`admin/launchpack/${this.$store.getters.admin.id}/talk/${this.talkId}/message/${this.value.id}`,
          params).then(res => {
          if(res.status === 200) {
            this.item.info = res.data.msg.info;
            this.item.file = res.data.msg.file;
            this.item.message = res.data.msg.message;
            this.editable = false;
          }
        });
      }
    }
  }

</script>

<style lang="stylus" scoped>
  .ic-edit
    font-size 17px
    margin-left 6px
    padding-bottom 6px
    color #333
  .ic-edit:hover
    color #ff5722
    cursor pointer

  .talk-memo-msg-container
    table
      border 1px solid #dddddd
      min-width 320px
      th
        width 110px
      th,td
        border 1px solid #dddddd
        padding 4px 8px
        font-size 12px


  input[type=file]
    position absolute
    width 0
    height 0
    border 0 !important

  .radio-group
    display flex
    align-items center
    gap 4px 12px
    flex-wrap wrap

  .radio-item
    display flex
    align-items center
    gap 4px
    font-size 12px

  .manager
    width 130px

  .button
    width 50px
    height 24px !important
    font-size 12px !important

  .button-group
    margin-top 8px
    display flex
    align-items center
    justify-content flex-end
    gap 4px
</style>
